export const styles = {
  unMuteButton: {
    width: "133px",
    height: "38px",
  },
  muteButton: {
    width: "115px",
    height: "38px",
  },
  dialogContent: {
    width: "486px",
  },
  onButton: {
    width: "161px",
  },
  offButton: {
    width: "171px",
  },
  closeIcon: {
    color: "text.primary",
  },
};
